var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-t-xs-20 p-b-xs-20" },
    [
      _vm.order && _vm.cart && _vm.receipt
        ? _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-12" }, [
                _c(
                  "div",
                  { staticClass: "m-b-xs-20" },
                  [
                    _c(
                      "ak-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.backToOrders },
                      },
                      [
                        _c("i", { staticClass: "ak-icon ak-button__icon" }, [
                          _vm._v("arrow_left"),
                        ]),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("Ga terug")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-lg-8" },
                [
                  _c(
                    "div",
                    { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel__header ak-panel__header--small",
                        },
                        [
                          _c("div", { staticClass: "ak-panel__title" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("Opmerkingen")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "m-l-auto",
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.openCommentsForm.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-lg fa-plus-square-o",
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("Opmerking toevoegen")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel__body ak-panel__body--small reading",
                          class: { muted: !_vm.order.comments },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.order.comments
                                  ? _vm.order.comments
                                  : _vm.$t("Geen opmerkingen")
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel__header ak-panel__header--small",
                        },
                        [
                          _c("div", { staticClass: "ak-panel__title" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("Bestelling")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("strong", { staticClass: "m-l-auto" }, [
                            _vm._v(_vm._s(_vm.cart.code)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          staticClass:
                            "ak-table ak-table--compact ak-panel__table",
                        },
                        [
                          _c("thead", [
                            _c("tr", { staticClass: "ak-table-row" }, [
                              _c("th", { staticClass: "ak-table-head" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("Artikel")) +
                                    "\n                                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "ak-table-head" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("Aantal")) +
                                    "\n                                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "ak-table-head" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("Prijs")) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            { staticClass: "ak-table-body" },
                            [
                              _vm._l(_vm.receipt.items, function (line) {
                                return _c(
                                  "tr",
                                  { staticClass: "ak-table-row" },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        line.shoppable.href
                                          ? _c("a", {
                                              staticClass:
                                                "ak-link ak-link--uppercase",
                                              attrs: {
                                                href: line.shoppable.href,
                                                target: "_blank",
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(line.title),
                                              },
                                            })
                                          : _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(line.title),
                                              },
                                            }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(line.quantity) +
                                            "\n                                    "
                                        ),
                                        _vm.getPartialCancellationLine(line)
                                          ? [
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "small",
                                                { staticClass: "text-muted" },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Gedeeltelijk geannuleerd: van @from naar @to",
                                                          {
                                                            "@from":
                                                              _vm.getPartialCancellationLine(
                                                                line
                                                              )
                                                                .originalQuantity,
                                                            "@to":
                                                              _vm.getPartialCancellationLine(
                                                                line
                                                              ).newQuantity,
                                                          }
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [_vm._v(_vm._s(line.amount.formatted))]
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.receipt.lines, function (line) {
                                return _c(
                                  "tr",
                                  { staticClass: "ak-table-row" },
                                  [
                                    _c("td", {
                                      staticClass: "ak-table-column",
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      staticClass:
                                        "ak-table-column text--right",
                                      domProps: {
                                        innerHTML: _vm._s(line.title),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [_vm._v(_vm._s(line.amount.formatted))]
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel__header ak-panel__header--small",
                        },
                        [
                          _c("div", { staticClass: "ak-panel__title" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("Verzending")) +
                                "\n                        "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          staticClass:
                            "ak-table ak-table--compact ak-panel__table",
                        },
                        [
                          _c("thead", [
                            _c("tr", { staticClass: "ak-table-row" }, [
                              _c("th", { staticClass: "ak-table-head" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("Artikel")) +
                                    "\n                                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "ak-table-head" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("Methode")) +
                                    "\n                                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "ak-table-head" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("Adres")) +
                                    "\n                                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "ak-table-head" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("Status")) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            { staticClass: "ak-table-body" },
                            _vm._l(_vm.inspector.items, function (item) {
                              return _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(item.title) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(item.shippingTypeAsString) +
                                      "\n                                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "ak-table-column" },
                                  [
                                    item.shippingTypeLocation
                                      ? [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                item.shippingTypeLocation.name
                                                  ? item.shippingTypeLocation
                                                      .name
                                                  : item.shippingTypeLocation
                                                      .full
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "ak-table-column" },
                                  [
                                    item.pickup && item.shippingType === 2
                                      ? [
                                          !item.pickup.dateDelivered
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openPickupForm(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-lg fa-arrow-right",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Markeren als geleverd bij afhaalpunt"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    color: "green",
                                                  },
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openPickupForm(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-lg fa-arrow-right",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Geleverd bij het afhaalpunt"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      : item.delivery &&
                                        [3, 4].includes(item.shippingType)
                                      ? [
                                          !item.delivery.dateDelivered
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openDeliveryForm(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-lg fa-arrow-right",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Markeren als verzonden"
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    color: "green",
                                                  },
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openDeliveryForm(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-lg fa-check",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("Verzonden")
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.digitalItems.length && _vm.order.isPaid
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel ak-panel--no-padding m-b-xs-20",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "ak-panel__header ak-panel__header--small",
                            },
                            [
                              _c("div", { staticClass: "ak-panel__title" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("Digitale tickets")) +
                                    "\n                        "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "table",
                            {
                              staticClass:
                                "ak-table ak-table--compact ak-panel__table",
                            },
                            [
                              _c(
                                "tbody",
                                _vm._l(_vm.digitalItems, function (item) {
                                  return _c(
                                    "tr",
                                    {
                                      key: item.id,
                                      staticClass: "ak-table-row",
                                    },
                                    [
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [_vm._v(_vm._s(item.title))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  ":/download/cart-pdf/" +
                                                  item.hashId,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t("Download PDF")
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cartItemsPickup.length && _vm.order.isPaid
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel ak-panel--no-padding m-b-xs-20",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "ak-panel__header ak-panel__header--small",
                            },
                            [
                              _c("div", { staticClass: "ak-panel__title" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("Afhaling")) +
                                    "\n                        "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "table",
                            {
                              staticClass:
                                "ak-table ak-table--compact ak-panel__table",
                            },
                            [
                              _c("thead", [
                                _c("tr", { staticClass: "ak-table-row" }, [
                                  _c("th", { staticClass: "ak-table-head" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("Artikel")) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "ak-table-head" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("Afhaalpunt")) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { staticClass: "ak-table-head" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.$t("Status")) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                { staticClass: "ak-table-body" },
                                _vm._l(_vm.cartItemsPickup, function (item) {
                                  return _c(
                                    "tr",
                                    { staticClass: "ak-table-row" },
                                    [
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.title) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                item.pickup.locationTitle
                                              ) +
                                              " "
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-muted" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    item.pickup.locationStreet
                                                  ) +
                                                  "\n                                        " +
                                                  _vm._s(
                                                    item.pickup
                                                      .locationStreetNumber
                                                  ) +
                                                  "\n                                        " +
                                                  _vm._s(
                                                    item.pickup
                                                      .locationPostalCode
                                                  ) +
                                                  "\n                                        " +
                                                  _vm._s(
                                                    item.pickup.locationCity
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          !item.pickup.dateDelivered
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openPickupForm(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-lg fa-arrow-right",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Markeren als geleverd bij afhaalpunt"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    color: "green",
                                                  },
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openPickupForm(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-lg fa-check",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Geleverd bij het afhaalpunt"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dellOrder
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel ak-panel--no-padding m-b-xs-20",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "ak-panel__header ak-panel__header--small",
                            },
                            [
                              _c("div", { staticClass: "ak-panel__title" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("Dell bestelling")) +
                                    " - " +
                                    _vm._s(_vm.$t("referentie")) +
                                    " "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.dellOrder.code)),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "table",
                            {
                              staticClass:
                                "ak-table ak-table--compact ak-panel__table",
                            },
                            [
                              _c(
                                "tbody",
                                { staticClass: "ak-table-body" },
                                _vm._l(_vm.dellOrder.items, function (item) {
                                  return _c(
                                    "tr",
                                    {
                                      key: item.id,
                                      staticClass: "ak-table-row",
                                    },
                                    [
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _vm._v(
                                            _vm._s(item.supplierPartAuxiliaryId)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [_vm._v(_vm._s(item.quantity))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [_vm._v(_vm._s(item.description))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hpOrder
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel ak-panel--no-padding m-b-xs-20",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "ak-panel__header ak-panel__header--small",
                            },
                            [
                              _c("div", { staticClass: "ak-panel__title" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("HP bestelling")) +
                                    " - " +
                                    _vm._s(_vm.$t("referentie")) +
                                    " "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.hpOrder.code)),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "table",
                            {
                              staticClass:
                                "ak-table ak-table--compact ak-panel__table",
                            },
                            [
                              _c(
                                "tbody",
                                { staticClass: "ak-table-body" },
                                _vm._l(_vm.hpOrder.items, function (item) {
                                  return _c(
                                    "tr",
                                    {
                                      key: item.id,
                                      staticClass: "ak-table-row",
                                    },
                                    [
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _vm._v(
                                            _vm._s(item.supplierPartAuxiliaryId)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [_vm._v(_vm._s(item.quantity))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [_vm._v(_vm._s(item.description))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.catalogueOrders, function (catalogueOrder) {
                    return _c(
                      "div",
                      {
                        key: catalogueOrder.id,
                        staticClass: "ak-panel ak-panel--no-padding m-b-xs-20",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "ak-panel__header ak-panel__header--small",
                          },
                          [
                            _c("div", { staticClass: "ak-panel__title" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    catalogueOrder.catalogue
                                      ? catalogueOrder.catalogue.title
                                      : _vm.$("Catalogus")
                                  ) +
                                  " " +
                                  _vm._s(_vm.$t("bestelling")) +
                                  " - " +
                                  _vm._s(_vm.$t("referentie")) +
                                  "  "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(catalogueOrder.code)),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "table",
                          {
                            staticClass:
                              "ak-table ak-table--compact ak-panel__table",
                          },
                          [
                            _c(
                              "tbody",
                              { staticClass: "ak-table-body" },
                              _vm._l(catalogueOrder.items, function (item) {
                                return _c(
                                  "tr",
                                  { key: item.id, staticClass: "ak-table-row" },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [_vm._v(_vm._s(item.articleCode))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [_vm._v(_vm._s(item.quantity))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [_vm._v(_vm._s(item.description))]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ak-panel__header ak-panel__header--small",
                        },
                        [
                          _c("div", { staticClass: "ak-panel__title" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("Historiek")) +
                                "\n                        "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          staticClass:
                            "ak-table ak-table--compact ak-panel__table",
                        },
                        [
                          _c("thead", [
                            _c("tr", { staticClass: "ak-table-row" }, [
                              _c("th", { staticClass: "ak-table-head" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("Datum")) +
                                    "\n                                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "ak-table-head" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.$t("Gebeurtenis")) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            { staticClass: "ak-table-body" },
                            [
                              _vm.order.dateCancelled
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("datetime")(
                                              _vm.order.dateCancelled
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t("Bestelling geannuleerd")
                                            ) +
                                            "\n                              "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order.dateOfShipping
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("datetime")(
                                              _vm.order.dateOfShipping
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t("Bestelling verzonden")
                                            ) +
                                            "\n                              "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order.paymentStatus === 1 &&
                              _vm.order.dateOfPayment
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("datetime")(
                                              _vm.order.dateOfPayment
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t(
                                                "Betaling ontvangen via @type",
                                                {
                                                  "@type":
                                                    _vm.inspector.paymentType
                                                      .title,
                                                }
                                              )
                                            ) +
                                            "\n                              "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(
                                _vm.partialCancellationLinesSorted,
                                function (line) {
                                  return _c(
                                    "tr",
                                    {
                                      key: "partial-cancel-" + line.id,
                                      staticClass: "ak-table-row",
                                    },
                                    [
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("datetime")(
                                                line.createdAt || line.updatedAt
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "ak-table-column" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Gedeeltelijke annulatie: @product (van @from naar @to)",
                                                  {
                                                    "@product":
                                                      _vm.getProductTitleById(
                                                        line.productId
                                                      ),
                                                    "@from":
                                                      line.originalQuantity,
                                                    "@to": line.newQuantity,
                                                  }
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm.inspector.isOrdered
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("datetime")(_vm.order.date)
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t("Bestelling geplaatst")
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _vm._v(
                                    _vm._s(_vm._f("datetime")(_vm.cart.date))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("Creatie winkelmandje"))
                                  ),
                                ]),
                              ]),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.inspector.isOrdered
                    ? [
                        _c(
                          "ak-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.openShippingForm },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("Verzending")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.order && !_vm.order.isPaid && !_vm.order.cancelled
                          ? _c(
                              "ak-button",
                              {
                                attrs: {
                                  size: "small",
                                  disabled: _vm.exactOrderPartial,
                                },
                                on: { click: _vm.openPartialCancelForm },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "Bestelling gedeeltelijk annuleren"
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.order && !_vm.order.isPaid && !_vm.order.cancelled
                          ? _c(
                              "ak-button",
                              {
                                attrs: {
                                  size: "small",
                                  enableConfirm: true,
                                  confirmTitle: _vm.$t("Ben je zeker?"),
                                  confirmText: _vm.$t(
                                    "Ben je zeker dat je deze bestelling wil annuleren?"
                                  ),
                                },
                                on: { click: _vm.cancelOrder },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t("Bestelling volledig annuleren")
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-4" }, [
                _c(
                  "div",
                  { staticClass: "ak-panel m-b-xs-20  ak-panel--no-padding" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "ak-panel__header ak-panel__header--small",
                      },
                      [
                        _c("div", { staticClass: "ak-panel__title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("Betaling")) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "m-l-auto",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.markAsPaid.apply(null, arguments)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-check" })]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.order.paymentStatus === 1
                      ? _c(
                          "table",
                          {
                            staticClass:
                              "ak-table ak-table--compact ak-panel__table",
                          },
                          [
                            _c("tbody", { staticClass: "ak-table-body" }, [
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("Betaling ontvangen")) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.ogm
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.ogm.ogm) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.inspector.paymentType
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.inspector.paymentType.title
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order.paymentCardHolderName
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.order.paymentCardHolderName
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order.getPaymentCardNumber
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.order.getPaymentCardNumber
                                            ) +
                                            "\n                                    "
                                        ),
                                        _vm.order
                                          .paymentCardExpirationMonthAndYear
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t("Vervaldatum")
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.order
                                                      .paymentCardExpirationMonthAndYear
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order.paymentMessage
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.order.paymentMessage) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      : !_vm.order.cancelled
                      ? _c(
                          "table",
                          {
                            staticClass:
                              "ak-table ak-table--compact ak-panel__table",
                          },
                          [
                            _c("tbody", { staticClass: "ak-table-body" }, [
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.$t("Betaling openstaande")) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.ogm
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.ogm.ogm) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.order.paymentMessage
                                ? _c("tr", { staticClass: "ak-table-row" }, [
                                    _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.order.paymentMessage) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c(
                                  "td",
                                  { staticClass: "ak-table-column" },
                                  [
                                    _c(
                                      "ak-button",
                                      { on: { click: _vm.markAsPaid } },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.$t("Markeren als betaald")
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.order.isPaid && !_vm.order.cancelled
                  ? _c(
                      "div",
                      {
                        staticClass: "ak-panel ak-panel--no-padding  m-b-xs-20",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "ak-panel__header ak-panel__header--small",
                          },
                          [
                            _c("div", { staticClass: "ak-panel__title" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("Factuur Exact Online")) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "table",
                          {
                            staticClass:
                              "ak-table ak-table--compact ak-panel__table",
                          },
                          [
                            _c("tbody", { staticClass: "ak-table-body" }, [
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _vm.exactOrder
                                  ? _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _vm.exactOrder.status === 3
                                          ? _c("i", {
                                              staticClass: "fa fa-check",
                                              staticStyle: { color: "green" },
                                            })
                                          : _c("i", {
                                              staticClass: "fa fa-warning",
                                            }),
                                        _vm._v(
                                          "\n\n                                    " +
                                            _vm._s(_vm.exactOrder.statusTitle) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "td",
                                      { staticClass: "ak-table-column" },
                                      [
                                        _c(
                                          "ak-button",
                                          {
                                            on: { click: _vm.createExactOrder },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "Factuur aanmaken in Exact Online"
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.isPaid
                  ? _c(
                      "div",
                      {
                        staticClass: "ak-panel ak-panel--no-padding  m-b-xs-20",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "ak-panel__header ak-panel__header--small",
                          },
                          [
                            _c("div", { staticClass: "ak-panel__title" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("Exact Online historiek")) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(0),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ak-panel ak-panel--no-padding  m-b-xs-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "ak-panel__header ak-panel__header--small",
                      },
                      [
                        _c("div", { staticClass: "ak-panel__title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("Factuuradres")) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "m-l-auto",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.openAddressForm.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-lg fa-edit" })]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "ak-panel__body ak-panel__body--small reading",
                      },
                      [
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.order.invoiceFirstName) +
                                "  " +
                                _vm._s(_vm.order.invoiceSurnames)
                            ),
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _vm.order.invoiceCompanyName
                            ? _c("strong", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.order.invoiceCompanyName) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.order.invoiceVat
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.order.invoiceVat)),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _vm.order.invoiceStreetAddress ||
                        _vm.order.invoiceStreetNumber ||
                        _vm.order.invoiceBoxNumber ||
                        _vm.order.invoicePostalCode ||
                        _vm.order.invoiceCity ||
                        _vm.order.invoiceCountryIso
                          ? _c("p", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.order.invoiceStreetAddress) +
                                  " " +
                                  _vm._s(_vm.order.invoiceStreetNumber) +
                                  " " +
                                  _vm._s(_vm.order.invoiceBoxNumber)
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.order.invoicePostalCode) +
                                  " " +
                                  _vm._s(_vm.order.invoiceCity) +
                                  " " +
                                  _vm._s(_vm.order.invoiceCountryIso) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.order.phone)
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "a",
                            { attrs: { href: "mailto:" + _vm.order.email } },
                            [_vm._v(_vm._s(_vm.order.email))]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", {
        attrs: { name: "childview" },
        on: { orderSaved: _vm.orderSaved },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      { staticClass: "ak-table ak-table--compact ak-panel__table" },
      [
        _c("tbody", { staticClass: "ak-table-body" }, [
          _c("tr", { staticClass: "ak-table-row" }, [
            _c("td", { staticClass: "ak-table-column" }, [
              _vm._v(
                "\n                                  todo\n                                "
              ),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }